import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
import StaffDetails from './StaffDetails';

const StaffApp = lazy(() => import('./StaffApp'));

const StaffAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/staff',
      element: <StaffApp />,
      children: [
        {
          path: ':id',
          element: <StaffDetails />,
        },
        // {
        //   path: ':id/edit',
        //   element: <></>,
        // },
      ],
    },
  ],
};

export default StaffAppConfig;
